<script>
  import servicoProjetoServico from '~modulos/servico-projeto/servico';
  import radio from '~componentes/Radio.vue';
  
  export default {
    components: { radio },
    props: {
      itensSolicitacao: {
        type: Array,
        required: true
      },
    },
    data() {
      return {
        item: this.camposItem(),
        adicionalDesconto: '0',
        servicosProjeto: [],
      }
    },
    methods: {
      listaServicos(idProjeto) {
        return servicoProjetoServico
          .lista(idProjeto)
          .then(servicosProjeto => {
            this.servicosProjeto = servicosProjeto;
          });
      },
      camposItem() {
        return {
          idServicoProjeto: '', 
          quantidadeItem: '', 
          valorItem: '', 
          adicionalItem: '', 
          observacaoItem: '',
          servicoProjeto: {
            permitirInfoValorUnitario: false,
            valorItem: null,
          },
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          });
      },
      servicoSelecionado() {
        return this.servicosProjeto.find(servicoProjeto => {
          return servicoProjeto.idServicoProjeto == this.item.idServicoProjeto;
        });
      },
      adicionar() {
        let valorAdicionalDesconto = this.$options.filters.formatarNumero(this.item.adicionalItem, true);
        
        if (this.adicionalDesconto == '1') {
          valorAdicionalDesconto *= -1;
        }
        
        let item = Object.assign(this.item, {
          quantidadeItem: parseInt(this.item.quantidadeItem),
          valorItem: this.$options.filters.formatarNumero(this.item.valorItem, true),
          adicionalItem: valorAdicionalDesconto,
          servicoProjeto: this.servicoSelecionado(),
        });
        
        this.itensSolicitacao.push(item);
        this.item = this.camposItem();
        this.adicionalDesconto = '0';

        this.$validator.reset();
        $('#tabs a[href="#tab-lista-servicos"]').tab('show');
      },
      setarServicoProjeto() {
        this.item.servicoProjeto = this.servicosProjeto.find(servicoProjeto => {
          return servicoProjeto.idServicoProjeto == this.item.idServicoProjeto;
        }) || this.camposItem().servicoProjeto;

        this.item.valorItem = this.$options.filters.formatarNumero(this.item.servicoProjeto.valorItem, false, false);
        this.item.observacaoItem = this.item.servicoProjeto.descricaoItem;
      },
    },
    mounted() {
    },
    computed: {
      totalItem() {
        let quantidade = parseInt(this.item.quantidadeItem || 0);
        let valorItem = this.$options.filters.formatarNumero(this.item.valorItem || 0, true);
        let adicionalDesconto = this.item.adicionalItem;
                
        adicionalDesconto = this.$options.filters.formatarNumero(adicionalDesconto || 0, true);
        
        return quantidade * valorItem + (this.adicionalDesconto == '0' ? adicionalDesconto : -1*adicionalDesconto);
      },
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('servicoItem')}">
          <label class="control-label" for="servico-item">Serviço</label>

          <select
            id="servico-item"
            class="form-control"
            @change="setarServicoProjeto"
            v-model="item.idServicoProjeto"
            data-vv-name="servicoItem"
            data-vv-as="serviço"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="c.idServicoProjeto" v-for="c in servicosProjeto">{{ c.descricaoItem }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('servicoItem')">{{ errors.first('servicoItem') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadeItem')}">
          <label class="control-label" for="quantidade-item">Quantidade</label>

          <input
            type="text"
            class="form-control"
            id="quantidade-item"
            v-model="item.quantidadeItem"
            data-vv-name="quantidadeItem"
            data-vv-as="quantidade"
            v-validate="'required'">

          <p class="text-danger" v-show="errors.has('quantidadeItem')">{{ errors.first('quantidadeItem') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group required" :class="{'has-error': errors.has('valorItem')}">
          <label class="control-label" for="valor-item">Valor unitário</label>

          <input
            type="text"
            class="form-control text-right"
            id="valor-item"
            :disabled="!item.servicoProjeto.permitirInfoValorUnitario"
            v-mascara="'moeda'"
            v-model="item.valorItem"
            data-vv-name="valorItem"
            data-vv-as="valor"
            v-validate="'required'">

          <p class="text-danger" v-show="errors.has('valorItem')">{{ errors.first('valorItem') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group">
            <radio
              v-model="adicionalDesconto"
              selected-value="0"
              type="success"
              :inline="true"
              class="no-margin-top margin-right-10 margin-bottom-3">
              Acréscimo
            </radio>
  
            <radio
              v-model="adicionalDesconto"
              selected-value="1"
              type="success"
              :inline="true"
              class="no-margin-top margin-bottom-3">
              Desconto
            </radio>

          <input
            type="text"
            class="form-control text-right"
            id="adicional-item"
            v-mascara="'moeda'"
            v-model="item.adicionalItem">
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group">
          <label class="control-label">Total</label>

          <input
            type="text"
            class="form-control text-right"
            :value="totalItem | formatarNumero"
            disabled>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group required" :class="{'has-error': errors.has('observacaoItem')}">
          <label class="control-label" for="complemento-item">Complemento</label>

          <textarea
            maxlength="1500"
            class="form-control"
            id="complemento-item"
            v-model="item.observacaoItem"
            data-vv-name="observacaoItem"
            data-vv-as="complemento"
            v-validate="'required'">
          </textarea>

          <p class="text-danger" v-show="errors.has('observacaoItem')">{{ errors.first('observacaoItem') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar serviço
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-multiservicos/componentes/compartilhado/FormAdicionarServicos.vue